module.exports = __webpack_public_path__ + "img/file_clear.3df7139a.svg";